import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadJsService } from '../../load-js/load-js.service';
import { ApiPartnerService } from '@app/api/api-partner.service';

@Component({
  selector: 'app-partner-form',
  templateUrl: './partner-form.component.html',
  styleUrls: ['./partner.component.css']
})
export class PartnerFormComponent implements OnInit {

  constructor(
    public restApi:ApiPartnerService,
    public LoadJsOrder: LoadJsService,
    private fb: FormBuilder,
    private router: Router, 
  ) { }

  formPartner = this.fb.group({
    search: [''],
    data_partner: [''],
  })

  formSelect = this.fb.group({
    partnertype: [''],
    manageby: [''],
  })

  data_partner:any = [];
  alert_success:any = false
  alert_failed:any = false
  message:any = false
  viewComcorp:any = {}
  searchval:any = {}
  Partnertype:any = []
  notfound:any = false

  ngOnInit() {
    this.loadStart()
  }

  loadStart() {
    this.loadPartnertype()
  }
  clearForm() {
    this.formSelect.reset();
  }

  searchPartner() {
    this.notfound = false
    // this.formPartner.get('search').setValue(this.data_partner)
    this.searchval = this.formPartner.get('search').value

    const data = {
      "search" : this.formPartner.get('search').value,
      "type" : "name",
    }

    this.restApi.getApipagelistpartner(data).subscribe((response: any) => {
      // if(response.status == true){

        console.log(response);

        this.alert_success = false;
        this.alert_failed = false;
        this.data_partner = response.data;

      // }else if(response.status == "failed"){
      //   this.notResult()
      // }
    });
  }

  viewPartner( data:any ){
    this.clearForm()
    this.viewComcorp = data
  }

  loadPartnertype() {
    return this.restApi.GetPartnertype().subscribe((output: any) => {
      console.log(output);
      this.Partnertype = output.data;
    })
  }

  notResult() {
    this.notfound = true
  }

  addPartner(data:any, el: HTMLElement){

    
    this.alert_success = false;
    this.alert_failed = false;

    const partnervalue = {
      "idcomcorp" : data.idcomcorp,
      "partnername" : data.partnername,
      "addressinstall" : data.addressinstall,
      "addressbilling" : data.addressbilling,
      "city" : data.city,
      "statusid" : data.statusid,
      "partnertype" : this.formSelect.get('partnertype').value,
      "manageby" : this.formSelect.get('manageby').value
    }

    console.log(partnervalue)
    
    this.restApi.postAddpartner(partnervalue)
      .subscribe((response: any) => {
        console.log(response);
        if(response.status == true){

          this.LoadJsOrder.loadScriptProductStb()
          this.alert_success = true
  
          setTimeout(()=>{
            el.scrollIntoView({behavior:"smooth"})
          }, 500);
          setTimeout(()=>{
            this.alert_success = false
          }, 6000);
          
        } else {
          this.LoadJsOrder.loadScriptProductStb()
          this.alert_failed = true
          setTimeout(()=>{
            this.alert_failed = false
          }, 6000);
        }
        
      }
    );
    
  }

}
